import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ShieldIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.39092 1.92659L5.33893 0.0596662L5.27615 0.0345506C5.09485 -0.0115169 4.9049 -0.0115169 4.7236 0.0345506L4.66081 0.0596662L0.608825 1.92659C0.417434 2.01471 0.257101 2.15856 0.148805 2.3393C0.040509 2.52004 -0.0107051 2.72926 0.00186414 2.93959L0.144186 5.3172C0.22495 6.68472 0.692832 8.00109 1.49327 9.11281C2.29371 10.2245 3.39371 11.0858 4.665 11.5961C4.77154 11.6441 4.88722 11.6684 5.00406 11.6673C5.11512 11.669 5.22519 11.6461 5.32638 11.6003C6.59923 11.0912 7.70099 10.2305 8.50298 9.1187C9.30497 8.00689 9.77409 6.68985 9.85556 5.32139L9.99789 2.94378C10.0113 2.73276 9.96052 2.52262 9.85217 2.34105C9.74382 2.15947 9.58301 2.01497 9.39092 1.92659ZM7.19749 4.85675L4.9622 7.36831C4.92584 7.40993 4.88159 7.44393 4.83202 7.46836C4.78245 7.49278 4.72853 7.50715 4.67337 7.51064H4.65244C4.54726 7.51141 4.44563 7.47256 4.3678 7.4018L2.83156 5.98695C2.74996 5.91146 2.70169 5.80665 2.69738 5.69557C2.69306 5.58449 2.73304 5.47624 2.80854 5.39464C2.88403 5.31305 2.98884 5.26478 3.09992 5.26046C3.211 5.25614 3.31925 5.29613 3.40085 5.37162L4.62314 6.49764L6.5696 4.30421C6.64432 4.22642 6.74618 4.18047 6.85394 4.17595C6.96171 4.17143 7.06706 4.20868 7.14803 4.27993C7.229 4.35119 7.27934 4.45095 7.28856 4.55841C7.29777 4.66588 7.26515 4.77275 7.19749 4.85675Z"
        fill="currentColor"
      />
    </svg>
  )
})

ShieldIcon.displayName = 'ShieldIcon'
